var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHelpCenter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6569 6.56896C20.7805 9.56835 20.7805 14.4312 17.6569 17.4306C14.5325 20.4293 9.46709 20.4293 6.34273 17.4306C3.21909 14.4312 3.21909 9.56835 6.34273 6.56896C9.46709 3.57027 14.5325 3.57027 17.6569 6.56896Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1683 8.95832C16.9174 10.6381 16.9174 13.3611 15.1683 15.0409C13.4185 16.72 10.5821 16.72 8.83233 15.0409C7.08324 13.3611 7.08324 10.6381 8.83233 8.95832C10.5821 7.27919 13.4185 7.27919 15.1683 8.95832Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28613 6.51477L8.77486 8.90395",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2246 15.0951L17.7133 17.4843",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7133 6.51477L15.2246 8.90395",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77584 15.0951L6.28711 17.4843",
    stroke: "currentColor",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHelpCenter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HelpCenter.6742729f.svg";
export { ForwardRef as ReactComponent };